/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var moyaToggle = MoyaContainer.get('core.toggle');
    MoyaEventHandler.on('ext.mobilemenu.init', function (e) {
        var regions = document.querySelector('#mobilemenu .qn__regions');
        moyaToggle.create(regions.querySelector('button'), regions.querySelector('ul'), 'regions', {});
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
